﻿import { object, number } from 'yup';

const quantityValidationRules = object().shape({
  quantity: number().min(0),
});

export const isValidQuantity = (newQuantity: string) => {
  return quantityValidationRules.isValid({ quantity: newQuantity });
};
